// @ import redux slice
import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './thunkapi';
import { setTokens, clearTokens } from '../../../utils/tokenUtils';

const initialState = {
  authLoader: false,
  message: '',
  authData: {},
  token: null,
  refreshToken: null,
  userId: null,
  changePasswordLoader: false,
  changePasswordError: '',
  roles: '',
  subscription: {
    plan: null,
    status: null,
    features: [],
    expiryDate: null
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => {
      clearTokens();
      return initialState;
    },
    updateSubscription: (state, action) => {
      state.subscription = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loginUser.pending, state => {
        state.authLoader = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const token = action.payload?.data?.token;
        const refreshToken = action.payload?.data?.refresh_token;
        setTokens(token, refreshToken);
        state.authData = action?.payload?.data;
        state.token = token;
        state.refreshToken = refreshToken || null;
        state.userId = action?.payload?.data?.id;
        state.authLoader = false;
        state.roles = action?.payload?.data?.rights;
        state.message = action?.payload?.responseDesc || '';
        state.error = !action?.payload?.data
          ? action?.payload?.responseDesc
          : '';
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.authLoader = false;
        state.error = action?.error?.message.includes('401')
          ? 'Invalid username or password.'
          : action?.error?.message;
      });
  },
});

export const { reset, storeUserData } = authSlice.actions;

export default authSlice.reducer;
